import styles from './BusinessChallengeDivider.module.css';
import { clsx } from 'clsx';

type BusinessChallengeDividerProps = {
  side: 'left' | 'right';
};

export const BusinessChallengeDivider = ({ side }: BusinessChallengeDividerProps) => {
  return (
    <div
      className={clsx(styles.businessChallengeDivider, {
        [styles.businessChallengeDividerLeft]: side === 'left',
        [styles.businessChallengeDividerRight]: side === 'right',
      })}
    />
  );
};
